export default Object.freeze({
    MASTER : 'control_node',
    LOAD_BALANCER :'load_balancer',
    WORKER : 'worker_node',
})
